import { useState, type ReactNode } from 'react'

import { Modal, type TModalProps } from '@/src/elements/modal/Modal'
import { Typography } from '@/src/elements/text/Typography'
import { useTranslate } from '@/src/lang/useTranslate'

import { ReportAbuseForm, type TReportAbuseFormProps } from './ReportAbuseForm'

type TReportAbuseModalProps = Omit<TReportAbuseFormProps, 'onSuccess' | 'onEnd'> &
  Pick<TModalProps, 'showModal'> & {
    onClose: VoidFunction
    onDone: VoidFunction
    text: string
  }

export const ReportAbuseModal = ({
  onClose,
  onDone,
  showModal,
  text,
  ...reportAbuseFormProps
}: TReportAbuseModalProps): ReactNode => {
  const [hasSucceeded, setHasSucceeded] = useState(false)
  const { t } = useTranslate()

  const handleSuccess = () => setHasSucceeded(true)

  const handleEnd = () => {
    if (hasSucceeded) onDone()
    onClose()
  }

  return (
    <Modal
      showModal={showModal}
      onCancel={handleEnd}
      title={t('app.report-abuse.report')}
      classNames={{ body: 'gap-6' }}
    >
      <Typography numberOfLines={10} className="rounded-lg bg-default-bg-light p-4 shadow-md" contrast="high">
        {text}
      </Typography>
      <ReportAbuseForm onEnd={handleEnd} onSuccess={handleSuccess} {...reportAbuseFormProps} />
    </Modal>
  )
}
